import { ajax_csrf_setup } from './ajax_csrf_setup'

import RegisterLogin from '../auth/register-login'

class HeaderNavView extends Backbone.View {

    get el() {
        return 'body';
    };

    get events() {
        return {
            'click #account .user': 'account_menu_toggle',
            'click #page': 'hide_menu',
            'touchstart #searchIcon': 'run_search',
            'click #searchIcon': 'run_search'
        };
    };

    account_menu_toggle (e) {
        e.stopPropagation();

        if ($('#account .menu.menu_expanded').length === 0) {
            $('#account .menu').show();
            $('#account .menu').addClass('menu_expanded');
        } else {
            let el = $('#account .menu');
            this.hide_menu(el);
        }
    };

    run_search (event) {
        event.target.closest('form').submit();
    };

    hide_menu (el) {
        if (el.length >= 1) {
            $(el).removeClass('menu_expanded');
        } else {
            $('#account .menu').removeClass('menu_expanded');
        }
    };

    site_warning (message) {
        $('<div></div>').addClass('site-warning').html(message).prependTo($('#header'));
    };

    is_alt () {
        // returns true if the header is in the alt-header state used for the create flow
        this.$el.hasClass('alt-header');
    };

};


class SignInModel extends Backbone.Model {

    get defaults() {
        return {
            user: null,
            signed_in: false
        };
    };

};


class SignInView extends Backbone.View {

    get el() {
        return '#header';
    };

    get events() {
        return {
            'click #signin_button': 'sign_in',
            'click #signout_button': 'sign_out',
            'click #register_button': 'register'
        };
    };

    initialize () {
        window.sign_in_model.signed_in = this.check_signed_in();
    };

    get_user () {
        // evite_cookie = window.evite.cookie('x-evite-auth')
        // evite_cookie && evite_cookie.split(':')[0]
        // doh, the auth cookie changed and we need some way to keep this functionality
        return window.tags.dl.email;
    };

    check_signed_in () {
        var r = 0;
        try {
            r = window.tags.dl.is_logged_in === 1;
        }
        finally {
            return r;
        }
    };

    get_next () {
        // for sign in and register, return the 'next' param if appropriate
        if (window.location.protocol === 'https:') {
            return getURLParameter('next');
        }

        if (!window.location.pathname.match(/(login|register).*/)) {
            let n = window.location.pathname;
            if (window.location.search) {
                n +=window.location.search;
            }
            return n;
        }
        return null;
    };

    sign_in (callback, next) {
        if (next == null) {
            next =null;
        }
        if (typeof callback !== 'function') {
            callback = null;
        }
        if ((callback == null) && !window.header_nav_view.is_alt()) {
            next = next || (this.get_next() || '');
            if (next) {
                next = '?next=' + encodeURIComponent(next);
            }
            window.location.href = urls.get('login') + next;
            return;
        }
        let sign_in_modal = new SecureModal({
            url: urls.get('login_modal'),
            onLogin: (r) => {
                window.tags.track_event('on_login');
                if (callback != null) {
                    this.set_signed_in_state(r.full_name);
                    return callback();
                } else {
                    return this.set_signed_in(r.full_name);
                }
            },
            onCancel: () => {
                return $(this).trigger('cancel');
            }
        });
        return sign_in_modal.show();
    };

    register (callback, next) {
        var register_modal;
        if (next == null) {
            next ='';
        }
        if (typeof callback !== 'function') {
            callback = null;
        }
        if ((callback == null) && !window.header_nav_view.is_alt()) {
            next = next || (this.get_next() || '');
            if (next) {
                next = '?next=' + encodeURIComponent(next);
            }
            window.location.href = urls.get('register') + next;
            return;
        }
        register_modal = new SecureModal({
            url: urls.get('register_modal'),
            onLogin: function(d) {
                return window.sign_in_view.set_signed_in(d.full_name);
            }
        });
        return register_modal.show();
    };

    sign_out () {
        window.tags.page_event('signout_button');
        return $.ajax({
            type: 'POST',
            url: urls.get('ajax_logout')
        }).done(function(data) {
            return window.location.assign(urls.get('login'));
        });
    };

    set_signed_in_state (full_name) {
        $('.logged_in').show();
        $('.signed_in').show();
        $('.logged_out').hide();
        $('.signed_out').hide();
        $('.signin').hide();
        window.sign_in_model.signed_in = true;
        window.sign_in_model.user = full_name;
        $('li.user .full_name').html(full_name);
        return $(this).trigger('success');
    };

    set_signed_in (full_name) {
        if (!window.prevent_page_reload_on_login) {
            return window.location.reload();
        } else {
            return this.set_signed_in_state(full_name);
        }
    };

    facebook_connect (opts) {
        window.tags.page_event('facebook_connect');

        let w = 580;
        let h = 400;
        let left = (screen.width / 2) - (w / 2);
        let top = (screen.height / 2) - (h / 2);
        let popup = window.open(urls.get('facebook_connect'), 'fb_auth', "width=" + w + ",height=" + h + ",top=" + top + ",left=" + left);
        if (popup == null) {
            if (!window.prevent_page_reload_on_login) {
                window.location.assign('/login/?next=' + encodeURIComponent(window.location.pathname));
            } else {
                alert("We tried to open a popup window to connect to Facebook. Please enable popup windows in your browser.");
            }
            return;
        }

        let check_connected = () => {
            if (popup.closed) {
                return $.ajax({
                    url: urls.get('ajax_authenticated'),
                    dataType: "json",
                    success: (data) => {
                        if (data && data.full_name) {
                            this.set_signed_in(data.full_name);
                            if (opts.onConnect) {
                                return opts.onConnect();
                            }
                        }
                    },
                    error: function(xhr, status, error) {
                        if (window.console != null) {
                            // console.log(`auth error: ${status}, error: ${error}, response: ${xhr.responseText}`);
                        }
                    }
                });
            } else {
                return setTimeout(check_connected, 300);
            }
        };

        return check_connected();
    };

    google_plus_connect (opts) {
        window.tags.page_event('google_plus_connect');

        let w = 580;
        let h = 400;
        let left = (screen.width / 2) - (w / 2);
        let top = (screen.height / 2) - (h / 2);
        let popup = window.open(urls.get('google_plus_connect'), 'gp_auth', "width=" + w + ",height=" + h + ",top=" + top + ",left=" + left);
        if (popup == null) {
            if (!window.prevent_page_reload_on_login) {
                window.location.assign('/login/?next=' + encodeURIComponent(window.location.pathname));
            } else {
                alert("We tried to open a popup window to connect to Google Plus. Please enable popup windows in your browser.");
            }
            return;
        }

        let check_connected = () => {
            if (popup.closed) {
                return $.ajax({
                    url: urls.get('ajax_authenticated'),
                    dataType: "json",
                    success: (data) => {
                        if (data && data.full_name) {
                            this.set_signed_in(data.full_name);
                            if (opts.onConnect) {
                                return opts.onConnect();
                            }
                        }
                    },
                    error: function(xhr, status, error) {
                        if (window.console != null) {
                            // console.log(`auth error: ${status}, error: ${error}, response: ${xhr.responseText}`);
                        }
                    }
                });
            } else {
                return setTimeout(check_connected, 300);
            }
        };

        return check_connected();
    };

};


class RegisterView extends Backbone.View {

    get el() {
        return 'div#header';
    };

    get events() {
        return {
            'click #register_button': 'register'
        };
    };

    register () {
        if ((typeof callback === "undefined" || callback === null) && !window.header_nav_view.is_alt()) {
            let next = '';
            if (window.location.protocol !== 'https' && !window.location.pathname.match(/(login|register).*/)) {
                next = '?next=' + encodeURIComponent(window.location.pathname);
            }
            window.location.href = urls.get('register') + next;
            return;
        }

        let register_modal = new SecureModal({
            url: urls.get('register_modal'),
            // use Login to match SignInView - in case the user hits 'login' and chooses to register
            onLogin: function(d) {
                return window.sign_in_view.set_signed_in(d.full_name);
            }
        });
        return register_modal.show();
    };

};


 function card_height (class_name) {
    let height = 400;
    switch (class_name) {
        case 'panel':
            height = 475;
            break;
        case 'postcard':
            height = 555;
            break;
        case 'full':
            height = 555;
            break;
        case 'big_and_tall':
            height = 735;
    }
    return `${height}px`;
};


function popup_window (loc, width, height, resizable, scrollbars, toolbar, dependent, window_name, location_bar, status_bar, align) {
    let left_position = 1;
    let top_position = 1;

    if (align === "center") {
        left_position = (screen.width ? (screen.width - width) / 2 : 0);
        top_position = (screen.height ? (screen.height - height) / 2 : 0);
    } else if (align === "topright") {
        left_position = (screen.width ? screen.width - width : 0);
        top_position = 1;
    } else if (align === "topcenter") {
        left_position = (screen.width ? (screen.width - width) / 2 : 0);
        top_position = 1;
    }

    let align_value = `top=${top_position},left=${left_position}`;
    let win = eval("window.open(loc, '${window_name}','width=${width},height=${height},resizable=${resizable},scrollbars=" + scrollbars + ",toolbar=" + toolbar + ",dependent=" + dependent + ",screenX=1,screenY=1,${align_value},location=${location_bar},status=${status_bar}')");
    win.focus();
};


function configure_selectboxes () {
    function toggle_unselected_style (target) {
        let _selectbox = $(target);
        if ((!_selectbox) || (_selectbox.val() === '') || (!_selectbox.val())) {
            $(_selectbox).addClass('unselected');
        } else {
            $(_selectbox).removeClass('unselected');
        }
    };

    let selectboxes = $('.select-holder select');
    selectboxes.each(function(index, selectbox) {
        toggle_unselected_style(selectbox);

        $(selectbox).change(function (e) {
            toggle_unselected_style(e.currentTarget);
        });
    });
};

class Popup {

    get defaults () {
        return {
            version: 2,
            cookie: 'pm1',
            expires: 7,
            delay: 1000,
            content: null,
            width: 760,
            height: 460
        };
    };

    constructor (options) {
        this.options = $.extend({}, this.defaults, options);
        this.$content = null;
    };

    fire () {
        // optionally fire if the cookie is missing
        if (this.options.cookie) {
            let v = window.evite.cookie(this.options.cookie);
            if ((v == null) || v !== (this.options.version + '')) {
                setTimeout(this.show, this.options.delay);
                window.evite.cookie(this.options.cookie, this.options.version, {
                    expires: this.options.expires
                });
            }
        }
        return this;
    };

    remove () {
        if (this.$content) {
            this.$content.detach();
            this.$content = null;
        }
        $("body").unbind('click', this.remove);
        return this;
    };

    render () {
        // no spaces in this block
        let overlay = $('<div class="interstitial-overlay" style="filter: alpha(opacity=50)"></div>');
        let container = $('<div class="interstitial"></div>');
        let call = $('<div class="call"><img src="/assets/images/modal/close.png" class="close-popup"></div>');
        call.appendTo(container);
        call.css({
            width: this.options.width,
            height: this.options.height
        });
        $(this.options.content).appendTo(call);
        return [overlay, container, call];
    };

    show () {
        let r = this.render();
        let overlay = r[0];
        this.$content = r[1];
        let call = r[2];
        overlay.appendTo($('body'));
        this.$content.appendTo($('body'));

        overlay.fadeIn(this.options.delay);
        call.fadeIn(this.options.delay);

        $("body").click(() => {
            if (this.$content) {
                this.$content.fadeOut(200, this.remove);
                return overlay.fadeOut(200, this.remove);
            }
        });

        return this;
    };

};


class PartnerIntegration extends Backbone.Model {

    get defaults() {
        return {
            event_type: null,
            nm: null,
            add: null,
            ct: null,
            st: null,
            zip: null,
            sdt: null,
            edt: null,
            tz: null,
            hn: null,
            et: null,
            ph: null,
            mess: null,
            mess_link: null
        };
    };

    initialize (values={}) {
        this.save = false;
        for (let k of Object.keys(this.defaults)) {
            let passed = values[k] || getURLParameter(k);
            this.set(k, passed);
            if (k !== 'event_type' && passed) {
                this.save = true;
            }
        }

        if (this.save) {
            store.set("partner_ev", this.attributes, {
                TTL: 600000
            });
        }
    };

    fetch () {
        var data;
        data = store.get("partner_ev");
        store.remove("partner_ev");
        return data;
    };

};

let partner_data = window.partner_data;
    if (!partner_data) {
        partner_data = {};
    }
window.partner_integration = new PartnerIntegration(partner_data);
window.RegisterLogin = RegisterLogin;


$(document).ready(function() {
    ajax_csrf_setup();
    if(window.is_modal === true) {
        // don't want to do this stuff in a modal
        return;
    }
    window.sign_in_model = new SignInModel();
    window.sign_in_view = new SignInView();
    window.header_nav_view = new HeaderNavView();
    window.Popup = Popup;


    window.card_height = card_height;
    window.popup_window = popup_window;
    if (window.is_mobile_site && !window.is_card) {
        window.menu_padding = 52; // allow space for top menu/nav bar on mobile
    } else {
        window.menu_padding = 0;
    }

    if (window.browserBlast != null) {
        window.browserBlast({
            devMode: false,
            supportedIE: '11',
            message: 'You are using an old version of Internet Explorer that is not supported by Evite. Please <a href="http://browsehappy.com" target="_blank">upgrade</a> for the best experience.'
        });
    }

    if (store && !window.location.hash && window.location.protocol !== 'https:') {
        if (store.get('cookie-warning', 0) === 0) {
            store.set('cookie-warning', 1);
            $(document).ready(function() {
                $('#cookie-warning').slideDown('fast', function() {
                    $('#cookie-warning').removeClass("hidden").removeAttr("style");
                    $('#header_spacer').height($('#header').height() + window.menu_padding);
                    $(window).scroll();
                    if (window.is_mobile_site) {
                        let navElem = $("#event_view_tabs");
                        if (navElem) {
                            // move down the event view tab bar by the height of the cookie warning div
                            let currTop = navElem.offset().top;
                            let warningHeight = $('#cookie-warning').outerHeight();
                            navElem.offset({top: currTop + warningHeight});
                        }
                    }
                });
            });
        }
    }

    $('#cookie-warning a.close').click(function() {
        $('#cookie-warning').hide();
        window.cookie_dismissed = true;
        $('#header_spacer').height($('#header').height() + window.menu_padding);
    });

    if (window.pm_popup_options != null) {
        window.pm_popup = new Popup(window.pm_popup_options).fire();
    }

    if ('ontouchstart' in document.documentElement) {
        let $body = $('body');
        $(document).on('focus', 'input,textarea', function() {
            $body.addClass('fixFixed');
        }).on('blur', 'input,textarea', function() {
            $body.removeClass('fixFixed');
        });
    }

    $("#header_spacer").outerHeight($("#header").outerHeight() + window.menu_padding);

    configure_selectboxes();
});


export { ajax_csrf_setup }


// WEBPACK FOOTER //
// ./assets/es6/common/main.es6